import moment from "moment";
import { useMemo } from "react";
import Loan from "typedef/Loan";

const useCurrentDuePaymentNumber = (loan?: Loan) => {
  const currentDuePaymentNumber = useMemo(() => {
    const startOfCurrentMonth = moment().startOf("months");
    const fundedAt = moment(
      loan?.borrowerSteps?.fundingVerification?.createdAt
    ).startOf("months");

    let indexPayment = Math.abs(fundedAt.diff(startOfCurrentMonth, "month"));
    let indexMonth = indexPayment;

    if (fundedAt.isAfter(startOfCurrentMonth) || indexMonth <= 1) {
      indexMonth = 2;
      indexPayment = 1;
    } else {
      indexMonth++;
    }

    return indexPayment - 1;
  }, [loan]);

  return currentDuePaymentNumber;
};

export default useCurrentDuePaymentNumber;
